
<div class="header-toolbar" *ngIf="revision">
  <h1>{{ revision.fullname }}</h1>
</div>

<!-- Toolbar -->
<div class="main btn-toolbar" *ngIf="revision">

  <div class="btn-group" *ngIf="revision.documents.length > 0 && revision.status === 'DRAFT'">
    <span class="label">Documents:</span>
    <div class="content">
      <a class="btn" [routerLink]="[ 'new']">
        <t-icon name="add"></t-icon>
        <span class="text">Ajouter</span>
      </a>
    </div>
  </div>

  <div class="btn-group">
    <span class="label">Révision:</span>
    <div class="content">

      <a class="btn" [routerLink]="['execute']" *ngIf="revision.documents.length > 0 &&revision.status === 'DRAFT'">
        <t-icon name="arrow_forward"></t-icon>
        <span class="text">Exécuter</span>
      </a>

      <button class="btn" (click)="deleteRevision()" *ngIf="revision.status === 'DRAFT'">
        <t-icon name="delete"></t-icon>
        <span class="text">Supprimer</span>
      </button>

      <button class="btn" (click)="duplicateRevision()" *ngIf="revision.documents.length > 0">
        <t-icon name="content_copy"></t-icon>
        <span class="text">Dupliquer</span>
      </button>

      <button class="btn" (click)="updateRevision('PRODUCTION')" *ngIf="revision.status === 'DRAFT' && revision.documents.length > 0">
        <t-icon name="check"></t-icon>
        <span class="text">Publier</span>
      </button>

      <button class="btn" (click)="updateRevision('PRODUCTION')" *ngIf="revision.status === 'ARCHIVE'">
        <t-icon name="settings_backup_restore"></t-icon>
        <span class="text">Restaurer</span>
      </button>

      <button class="btn" (click)="updateRevision('ARCHIVE')" *ngIf="revision.status === 'PRODUCTION'">
        <t-icon name="archive"></t-icon>
        <span class="text">Archiver</span>
      </button>
    </div>
  </div>

</div>
<!-- /Toolbar -->

<table *ngIf="revision && revision.documents.length > 0">
  <thead>
    <tr>
      <th>Document</th>
      <th style="width: 300px">Fichier modèle</th>
      <th style="width: 240px">Cible(s)</th>
      <th>Dernière modif</th>
      <th>Date d'ajout</th>
      <th style="width: 100px;"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let document of revision.documents" (click)="view(document, $event)">
      <td name="Document">{{ document.name }}</td>
      <td name="Fichier modèle" style="width: 300px">
        {{ document.filename }}
      </td>
      <td name="Cible(s)" style="width: 240px">
        {{ dossierModel.getTargetLabel(document.target) }}
      </td>
      <td name="Dernière modif" style="width: 130px">{{ document.updated_at | tzdate:'short' }}</td>
      <td name="Date d'ajout" style="width: 110px">{{ document.created_at | tzdate:'short' }}</td>

      <td style="width: 100px;" class="actions" *ngIf="revision.status === 'DRAFT'">

        <a class="action-btn" title="Modifer" [routerLink]="[ document.id, 'edit']">
          <t-icon name="mode_edit"></t-icon>
        </a>
        <a class="action-btn" title="Supprimer" (click)="delete(document)">
          <t-icon name="delete"></t-icon>
        </a>
      
      </td>

      <td style="width: 50px;" class="actions" *ngIf="revision.status !== 'DRAFT'">
        <a class="action-btn" title="Télécharger"
          href="{{ '/files/documents/' + operation.id + '/' + revision.id + '/' + document.id }}">
          <t-icon name="file_download"></t-icon>
        </a>
      </td>
    </tr>
  </tbody>
</table>

<div *ngIf="revision && revision.documents.length === 0" class="empty-table">

  <p>Aucun document n'est attaché à cette révision</p>

  <a class="btn" [routerLink]="['new']">
    <t-icon name="add"></t-icon>
    <span class="text">Ajouter un document</span>
  </a>

</div>

<div *ngIf="!revision" class="empty-table">
  <p>Chargement...</p>
</div>